import ApiService from "./MainServices";
import StorageService from "./StorageService";

const serviceApi = process.env.REACT_APP_SERVICE_URL;

const storageService = new StorageService();
const apiService = new ApiService();

export const API = {
  searchPid: serviceApi + "/v1/transcript/search?id={0}",
  getPatientDetails: serviceApi + "/v2/transcript/patient/{0}",
  getModes: serviceApi + "/v2/transcript/service/type?status=true",
  getAllRelation: serviceApi + "/v2/transcript/family/relations",
  reasonsForConsultation:
    serviceApi + "/v2/transcript/appointment/reason?status=true",
  getAccountsForPid: serviceApi + "/v2/transcript/patient/account/{0}",
  // getFamilyMembers: serviceApi + "/v2/transcript/family/member/{0}",
  getFamilyMembers: serviceApi + "/v2/transcript/family/member/extended/{0}",
  getPlansForPid:
    serviceApi + "/v2/transcript/account/plans/patient/{0}?keepAllPlans=true",
  getServices: serviceApi + "/v2/transcript/account/plans/service/patient",
  getServiceProvider:
    serviceApi + "/v2/transcript/account/plans/service/provider/patient",
  getPrice:
    serviceApi + "/v2/transcript/account/plans/service/patient/customized",
  getAvailableSlots: serviceApi + "/v2/transcript/appointment/available-slots",
  getAppointments:
    serviceApi + "/v2/transcript/appointment?includeDetails=true",
  getHomeSampleDates:
    serviceApi + "/v2/transcript/appointment/booking/config/{0}/{1}",
  getAvailCareDates:
    serviceApi +
    "/v2/transcript/appointment/booking/config/{0}/{1}?program=avail",
  getBookingConfigByVendor:
    serviceApi + "/v2/transcript/appointment/booking/config/vendor",
  checkAddressServiceable:
    serviceApi + "/v2/transcript/ms/booking/service/check",
  createAppointment: serviceApi + "/v2/transcript/appointment/create",
  getPatientAddress: serviceApi + "/v1/transcript/address/{0}",
  rescheduleAppointment: serviceApi + "/v2/transcript/appointment/reschedule",
  getServiceByFilter: serviceApi + "/v2/transcript/service/service/filter",
  getSPByFilter: serviceApi + "/v2/transcript/service/provider/filter",
  getLanguages:
    serviceApi +
    "/v2/transcript/account/plans/service/provider/language/options",
  locationFilter:
    serviceApi +
    "/v2/transcript/account/plans/service/provider/location/filters",
  profileInfoUpdate: serviceApi + "/v2/transcript/patients/profile/update",
  getPatientActiveAcc:
    serviceApi +
    "/v2/transcript/patient/account/{0}?includeDetails=true&status=true",
  getPatientPlans: serviceApi + "/v2/transcript/account/patient/plan/{0}",
  getFilteredPlans: serviceApi + "/v2/transcript/account/plans/filters",
  assignPlan: serviceApi + "/v2/transcript/account/patient/plan/assign",
  getPincodeData: serviceApi + "/v2/transcript/address/pincode/{0}",
  placesAutocomplete:
    serviceApi + "/v2/transcript/utility/maps/places/autocomplete",
  placeIdToCoordinates:
    serviceApi + "/v2/transcript/utility/maps/coordinates/place",
  latLngToAddress:
    serviceApi + "/v2/transcript/utility/maps/address/coordinates",
  coordinatesFromAddressId:
    serviceApi + "/v2/transcript/address/coordinates/{0}",
  getPriorityVendors: serviceApi + "/v2/transcript/ms/vendo/priority",
  generatePaymentLink:
    serviceApi + "/v2/transcript/appointment/payment/initiate",
  checkCurrentWalletDetails:
    serviceApi +
    "/v2/transcript/appointment/getpaymentsublimit?sublimit=true&wallet=true",
};

const header = {
  "Content-Type": "application/json",
  auth_token: storageService.get("token"),
  phone_no: storageService.get("phone_no"),
};

class NavigoDashboardUtils {
  constructor() {}
  getPatient(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.searchPid, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getPatientDetails(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.getPatientDetails, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getModes(onResponse: any, onError: any) {
    let url = API.getModes;
    apiService.get(url, header, onResponse, onError);
  }
  getAllRelation(onResponse: any, onError: any) {
    let url = API.getAllRelation;
    apiService.get(url, header, onResponse, onError);
  }
  fetchReasonsForConsultation(onResponse: any, onError: any) {
    let url = API.reasonsForConsultation;
    apiService.get(url, header, onResponse, onError);
  }
  getAccountsForPid(id: string, onResponse: any, onError: any) {
    let url = stringFormat(API.getAccountsForPid, id);
    apiService.get(url, header, onResponse, onError);
  }
  getFamilyMembers(id: string, onResponse: any, onError: any) {
    let url = stringFormat(API.getFamilyMembers, id);
    apiService.get(url, header, onResponse, onError);
  }
  getPlansForPid(id: string, onResponse: any, onError: any) {
    let url = stringFormat(API.getPlansForPid, id);
    apiService.get(url, header, onResponse, onError);
  }
  getServices(payload: any, onResponse: any, onError: any) {
    let url = API.getServices;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getServiceProvider(payload: any, onResponse: any, onError: any) {
    let url = API.getServiceProvider;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getPrice(payload: any, onResponse: any, onError: any) {
    let url = API.getPrice;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getAvailableSlots(payload: any, onResponse: any, onError: any) {
    let url = API.getAvailableSlots;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getHomeSampleDates(
    pid: number,
    planId: number,
    onResponse: any,
    onError: any,
  ) {
    let url = stringFormat(API.getHomeSampleDates, pid, planId);
    apiService.get(url, header, onResponse, onError);
  }
  getAvailCareDates(
    pid: number,
    planId: number,
    onResponse: any,
    onError: any,
  ) {
    let url = stringFormat(API.getAvailCareDates, pid, planId);
    apiService.get(url, header, onResponse, onError);
  }
  getBookingConfigByVendor(payload: any, onResponse: any, onError: any) {
    let url = API.getBookingConfigByVendor;
    apiService.post(url, header, payload, onResponse, onError);
  }
  checkAddressServiceable(payload: any, onResponse: any, onError: any) {
    let url = API.checkAddressServiceable;
    apiService.post(url, header, payload, onResponse, onError);
  }
  createAppointment(payload: any, onResponse: any, onError: any) {
    let url = API.createAppointment;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getPatientAddress(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.getPatientAddress, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getLanguages(payload: any, onResponse: any, onError: any) {
    let url = API.getLanguages;
    apiService.post(url, header, payload, onResponse, onError);
  }
  locationFilter(payload: any, onResponse: any, onError: any) {
    let url = API.locationFilter;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getPatientActiveAcc(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.getPatientActiveAcc, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getPatientPlans(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.getPatientPlans, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getFilteredPlans(payload: any, onResponse: any, onError: any) {
    let url = API.getFilteredPlans;
    apiService.post(url, header, payload, onResponse, onError);
  }
  assignPlan(payload: any, onResponse: any, onError: any) {
    let url = API.assignPlan;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getPincodeData(pincode: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.getPincodeData, pincode);
    apiService.get(url, header, onResponse, onError1);
  }
  //--------------
  checkPidStatus(patientId: string, onResponse: any, onError1: any) {
    let url = stringFormat(API.searchPid, patientId);
    apiService.get(url, header, onResponse, onError1);
  }
  getAppointments(payload: any, onResponse: any, onError: any) {
    let url = API.getAppointments;
    apiService.post(url, header, payload, onResponse, onError);
  }
  rescheduleAppointment(payload: any, onResponse: any, onError: any) {
    let url = API.rescheduleAppointment;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getServiceByFilter(payload: any, onResponse: any, onError: any) {
    let url = API.getServiceByFilter;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getSPByFilter(payload: any, onResponse: any, onError: any) {
    let url = API.getSPByFilter;
    apiService.post(url, header, payload, onResponse, onError);
  }
  updateProfileInfo(payload: any, onResponse: any, onError: any) {
    let url = API.profileInfoUpdate;
    apiService.put(url, header, payload, onResponse, onError);
  }
  getPlacesAutocomplete(payload: any, onResponse: any, onError: any) {
    let url = API.placesAutocomplete;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getCoordinatesByPlaceId(payload: any, onResponse: any, onError: any) {
    let url = API.placeIdToCoordinates;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getAddressByCoordinates(payload: any, onResponse: any, onError: any) {
    let url = API.latLngToAddress;
    apiService.post(url, header, payload, onResponse, onError);
  }
  getCoordinatesFromAddressId(payload: any, onResponse: any, onError: any) {
    let url = stringFormat(API.coordinatesFromAddressId, payload);
    apiService.get(url, header, onResponse, onError);
  }
  getPriorityVendors(onResponse: any, onError: any) {
    let url = API.getPriorityVendors;
    apiService.get(url, header, onResponse, onError);
  }
  generatePaymentLink(payload: any, onResponse: any, onError: any) {
    let url = API.generatePaymentLink;
    apiService.post(url, header, payload, onResponse, onError);
  }
  checkCurrentWalletDetails(payload: any, onResponse: any, onError: any) {
    let url = API.checkCurrentWalletDetails;
    apiService.post(url, header, payload, onResponse, onError);
  }
}

export default NavigoDashboardUtils;

function stringFormat(template: string, ...args: any[]) {
  return template.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] != "undefined" ? args[number] : match;
  });
}
